define(function (require, exports, module) {
    'use strict';

    /**
     * @param {string} string
     * @returns {string}
     */
    function escapeForRegExp(string) {
        if (!string) {
            return string;
        }

        return string.replace(/([?!^$.(){}:|=[\]+\-\/\\*])/g, '\\$1');
    }

    module.exports = escapeForRegExp;
});
